import { z } from 'zod';
import { helperSchema } from '../../zodExtensions.js';
// the main source of truth for variants on platform
export const variant = z.object({
    idFromPlatform: z.string(),
    price: z.coerce.number(),
    quantity: z.number(),
    grams: z.number(),
    // this is the title of the product technically / usually displayed with options
    title: z.string(),
    options: z.array(z.object({ name: z.string(), value: z.string() })),
    // this is the title of the variant, which is a combination of the product title and the options
    titleWithOptions: z.string(),
    optionsValueString: z.string(),
    sku: z.string().nullish(),
    imgUrl: z.string().nullish(),
});
export const storeProductVariant = variant.extend({
    id: z.number(),
});
// * variant exchange
export const storeProduct = z.object({
    id: z.number(),
    title: z.string(),
    idFromPlatform: z.string(),
    imgUrl: z.string().nullable(),
    variants: z.array(storeProductVariant),
});
export const registrationProductVariant = storeProductVariant;
export const registrationProduct = storeProduct;
export const productType = z.object({
    id: z.number(),
    name: z.string(),
});
export const productTag = z.object({
    id: z.number(),
    name: z.string(),
});
export const productCollection = z.object({
    id: z.number(),
    name: z.string(),
});
export const storeProductGroup = z.object({
    id: z.number(),
    name: helperSchema.nonEmptyString,
    types: z.array(productType),
    tags: z.array(productTag),
    collections: z.array(productCollection),
    lastUpdatedOn: helperSchema.optionalizedString,
    createdOn: z.string().optional(),
});
export const storeProductMinimum = storeProduct.pick({
    id: true,
    title: true,
    idFromPlatform: true,
    imgUrl: true,
});
export const storeProductGroupCreate = storeProductGroup.omit({ id: true });
//# sourceMappingURL=storeProduct.js.map